// `account` is not consumed by the store: it is declared purely so the payload type does not lie
// about what the server actually sends (the `id` serialization group always includes it).
// `actorUserId`, `resourceId`, `facilityId` and `beneficiaryId` are bare integers, never `{ id }`:
// the server carries no foreign key to those entities, so there is no relation to serialize.
export type AuditEntryPayload = {
	readonly id: number;
	readonly account: { readonly id: number } | null;
	readonly createdAt: string;
	readonly updatedAt: string;
	readonly action: { readonly value: string; readonly label: string };
	readonly outcome: { readonly value: string; readonly label: string };
	readonly actorUserId: number | null;
	readonly resourceType: { readonly value: string; readonly label: string } | null;
	readonly resourceId: number | null;
	readonly facilityId: number | null;
	readonly beneficiaryId: number | null;
	readonly ipAddress: string | null;
	readonly context: string | null;
};

export type AuditEntriesFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly AuditEntryPayload[];
};

export type AuditEntriesFetchedAction = {
	type: 'AUDIT_ENTRIES_FETCHED';
	payload: AuditEntriesFetchedPayload;
	accountId: number;
};

export default (payload: AuditEntriesFetchedPayload, accountId: number): AuditEntriesFetchedAction => ({
	type: 'AUDIT_ENTRIES_FETCHED',
	payload,
	accountId,
});
